
export const numberWithCommas = (number) => {
    return new Intl.NumberFormat().format(number);
};